import { render } from "./PartnerManage.vue?vue&type=template&id=3cb3182d"
import script from "./PartnerManage.vue?vue&type=script&lang=js"
export * from "./PartnerManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__